import auth from './auth/auth-store';
import core from './core/core-store';
import credits from './credits/credits-store';
import scaffold from './scaffold/scaffold-store';
import builder from './builder/builder-store';
import property from './builder/property/property-store';
import matcher from './builder/builder-matcher-store';

import propertyCurrent from './builder/property/property-current-store';
import entityCurrent from './builder/entity/entity-current-store';
import fieldCurrent from './builder/field/field-current-store';
import fieldValidationCurrent from './builder/field/field-validation-current-store';
import entityOrFieldReference from './builder/data/entity-or-field-reference-store';

import entityLabelPlural from './builder/entity/entity-label-plural-store';
import entityLabel from './builder/entity/entity-label-store';
import entityName from './builder/entity/entity-name-store';
import entityNamePlural from './builder/entity/entity-name-plural-store';
import entityProperty from './builder/entity/entity-property-store';
import entity from './builder/entity/entity-store';

import relationshipCurrent from './builder/relationship/relationship-current-store';
import relationship from './builder/relationship/relationship-store';

import fieldLabelPlural from './builder/field/field-label-plural-store';
import fieldLabel from './builder/field/field-label-store';
import fieldName from './builder/field/field-name-store';
import fieldNamePlural from './builder/field/field-name-plural-store';
import fieldProperty from './builder/field/field-property-store';
import fieldType from './builder/field/field-type-store';
import field from './builder/field/field-store';
import fieldRelation from './builder/field/field-relation-store';
import fieldValidation from './builder/field/field-validation-store';

import project from './project/project-store';

export default {
  modules: {
    core,
    scaffold,
    auth,
    credits,
    project,
    builder: Object.assign({}, builder, {
      modules: {
        relationship,
        relationshipCurrent,
        matcher,
        property,
        propertyCurrent,
        entityCurrent,
        fieldCurrent,
        fieldValidationCurrent,
        entityOrFieldReference,
        entityLabelPlural,
        entityLabel,
        entityName,
        entityNamePlural,
        entityProperty,
        entity,
        fieldLabelPlural,
        fieldLabel,
        fieldName,
        fieldNamePlural,
        fieldProperty,
        fieldType,
        field,
        fieldRelation,
        fieldValidation,
      },
    }),
  },
};
